import { render, staticRenderFns } from "./PaymentNav.vue?vue&type=template&id=b94bbcc6&"
import script from "./PaymentNav.vue?vue&type=script&lang=js&"
export * from "./PaymentNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports